import { useDispatch, useSelector } from 'react-redux'

import Button from 'components/UI/Button'

import { setCreateBannerStep, setStep } from 'routing/fetchingfunction/user/user.action'
import { BACKEND_REGISTRATION_CODES } from '../../../../../../constants'

import {
  selectBannersCreateBanner,
  selectSelectedCategories,
} from 'routing/fetchingfunction/user/user.reducer'

import testsPassed from 'assets/image/banner-completion.png'
import allCategoriesSetUp from 'assets/image/all-categories-set-up.png'
import { useAvailableCategories } from 'hooks'

const FinalizeScreen = ({ onFinalize }) => {
  const dispatch = useDispatch()

  const banners = useSelector(selectBannersCreateBanner)
  const selectedCategories = useSelector(selectSelectedCategories)
  const { formattedClassBannerCategories } = useAvailableCategories()

  const lastBannerName = banners[banners.length - 1]?.class_banner_category?.name

  // const isLast = banners.length >= selectedCategories?.length
  const isLast = formattedClassBannerCategories.length === 0

  const handleClick = () => {
    if (isLast) {
      if (onFinalize) {
        onFinalize()
      } else {
        dispatch(setStep(BACKEND_REGISTRATION_CODES.COMPLETED))
      }
    } else {
      dispatch(setCreateBannerStep(1))
    }
  }

  return (
    <div className="flex flex-col items-center justify-start !text-white-50">
      <h2 className="text-5xl font-bold">Congratulations!</h2>

      <h3 className="text-4xl mt-[16px] text-center font-bold">
        {!isLast ? (
          <>{lastBannerName} banner created successfully!</>
        ) : (
          'All Categories Have Been Created Successfully'
        )}
      </h3>

      <div className="mt-20 mb-16">
        <img className="block" src={testsPassed} alt="passed" />
        {/* <img className="block" src={!isLast ? allCategoriesSetUp : testsPassed} alt="passed" /> */}
      </div>

      {!isLast && (
        <Button
          className={'max-w-lg w-full border shadow !border-gray-700/30 shadow-slate-700 '}
          onClick={handleClick}
        >
          Continue {isLast ? 'to Complete Account Setup' : 'to Set Up Next Banner'}
        </Button>
      )}
      <Button
        className={'max-w-lg w-full my-4 border shadow !border-gray-700/30 shadow-slate-700 '}
        onClick={() => dispatch(setStep(BACKEND_REGISTRATION_CODES.COMPLETED))}
      >
        Finish Registration{' '}
      </Button>
    </div>
  )
}

export default FinalizeScreen
